import Spinner from '../../components/Spinner';
import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const LOCO_VACIA = { numero: '', uic: '', modelo: '336', tipo: 'exploradora', capacidad_combustible: 5000, tiene_adblue: true, capacidad_adblue: 530, consumo_estimado_lkm: 0.058, ubicacion: '' };

export default function GestionFlota() {
  const [locomotoras, setLocomotoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(LOCO_VACIA);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/locomotoras/').then(r => setLocomotoras(r.data)).finally(() => setLoading(false));
  };

  const abrirNueva = () => { setEditando(null); setForm(LOCO_VACIA); setModal(true); };
  const abrirEditar = (l) => {
    setEditando(l);
    setForm({ numero: l.numero, uic: l.uic || '', modelo: l.modelo || '336', tipo: l.tipo, capacidad_combustible: l.capacidad_combustible || 5000, tiene_adblue: l.tiene_adblue, capacidad_adblue: l.capacidad_adblue || 530, consumo_estimado_lkm: l.consumo_estimado_lkm || 0.058, ubicacion: l.ubicacion || '' });
    setModal(true);
  };

  const guardar = async () => {
    if (!form.numero) { setMsg('El numero es obligatorio'); return; }
    setSaving(true);
    try {
      if (editando) {
        await api.patch(`/locomotoras/${editando.id}`, form);
        setMsg('Locomotora actualizada');
      } else {
        await api.post('/locomotoras/', form);
        setMsg('Locomotora creada');
      }
      setModal(false);
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const darBaja = async (l) => {
    if (!window.confirm(`Dar de baja la locomotora ${l.numero}?`)) return;
    await api.patch(`/locomotoras/${l.id}`, { activa: false });
    setMsg(`${l.numero} dada de baja`);
    cargar();
    setTimeout(() => setMsg(''), 3000);
  };

  const reactivar = async (l) => {
    await api.patch(`/locomotoras/${l.id}`, { activa: true });
    setMsg(`${l.numero} reactivada`);
    cargar();
    setTimeout(() => setMsg(''), 3000);
  };

  if (loading) return <Spinner />;

  const activas = locomotoras.filter(l => l.activa);
  const bajas = locomotoras.filter(l => !l.activa);

  const renderTabla = (lista, titulo) => (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 10 }}>{titulo} ({lista.length})</div>
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f8f6' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Numero</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>UIC</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Tipo</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Modelo</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>AdBlue</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {lista.map(l => (
              <tr key={l.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 14px', fontWeight: 500 }}>{l.numero}</td>
                <td style={{ padding: '10px 14px', color: '#888' }}>{l.uic || '—'}</td>
                <td style={{ padding: '10px 14px' }}>{l.tipo}</td>
                <td style={{ padding: '10px 14px' }}>{l.modelo}</td>
                <td style={{ padding: '10px 14px' }}>{l.tiene_adblue ? 'Sí' : 'No'}</td>
                <td style={{ padding: '10px 14px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => abrirEditar(l)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>Editar</button>
                    {l.activa
                      ? <button onClick={() => darBaja(l)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 12, color: '#c00' }}>Baja</button>
                      : <button onClick={() => reactivar(l)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #97c459', background: '#eaf3de', cursor: 'pointer', fontSize: 12, color: '#3b6d11' }}>Reactivar</button>
                    }
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Gestion de flota</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Alta, baja y modificacion de locomotoras</p>
        </div>
        <button onClick={abrirNueva} style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          + Nueva locomotora
        </button>
      </div>

      {msg && <div style={{ background: '#eaf3de', border: '1px solid #97c459', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#3b6d11' }}>{msg}</div>}

      {renderTabla(activas, 'Activas')}
      {bajas.length > 0 && renderTabla(bajas, 'Bajas')}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModal(false); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 460, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>{editando ? `Editar — ${editando.numero}` : 'Nueva locomotora'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Numero *</label>
                <input value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>UIC</label>
                <input value={form.uic} onChange={e => setForm({ ...form, uic: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Modelo</label>
                <input value={form.modelo} onChange={e => setForm({ ...form, modelo: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Tipo</label>
                <select value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="exploradora">Exploradora</option>
                  <option value="ferrovial">Ferrovial</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Cap. combustible (L)</label>
                <input type="number" value={form.capacidad_combustible} onChange={e => setForm({ ...form, capacidad_combustible: parseFloat(e.target.value) })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Ubicacion</label>
                <input value={form.ubicacion} onChange={e => setForm({ ...form, ubicacion: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>AdBlue</label>
                <select value={form.tiene_adblue ? 'si' : 'no'} onChange={e => setForm({ ...form, tiene_adblue: e.target.value === 'si' })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="si">Sí</option>
                  <option value="no">No</option>
                </select>
              </div>
              {form.tiene_adblue && (
                <div>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Cap. AdBlue (L)</label>
                  <input type="number" value={form.capacidad_adblue} onChange={e => setForm({ ...form, capacidad_adblue: parseFloat(e.target.value) })}
                    style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={guardar} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : editando ? 'Guardar cambios' : 'Crear'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
